import Vue from 'vue'
import Vuex from 'vuex'
import { agentStore } from './agent'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    agent: agentStore
  }
})
